import { useEffect, useState } from "react";
import Input from "../../Component/Common/Input";
import Button from "../../Component/Common/Button";
import { connect, useDispatch, useSelector } from "react-redux";
import UserImage from "../../assets/images/no-profile.jpg";

import { uploadFile } from "../../util/AwsFunction";
import {
  getOrgProfile,
  resetPassword,
  updateOrgDetails,
} from "../../store/organization/organization.action";
import Textarea from "../../Component/Common/Textarea";
import PageContainer from "../../Component/Common/Page";
import {
  getOrgMemberProfile,
  updateMemberDetails,
} from "../../store/loggedUser/loggedUser.action";
import { apiInstance } from "../../util/api-new";
import Select from "../../Component/Common/Select";
import { setToast } from "../../util/toast";

function OrgProfile() {
  const { orgProfile } = useSelector((state) => state.organization);
  const { profile } = useSelector((state) => state.loggedUser);

  const dispatch = useDispatch();

  const [userName, setUserName] = useState();
  const [userEmail, setUserEmail] = useState();
  const [profileImage, setProfileImage] = useState();

  const [data, setData] = useState();
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [about, setAbout] = useState();
  const [oldPassword, setOldPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [showImage, setShowImage] = useState();
  const [address, setAddress] = useState({
    street: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
  });
  const [error, setError] = useState({
    name: "",
    email: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  useEffect(() => {
    dispatch(getOrgProfile());
    dispatch(getOrgMemberProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profile) {
      setUserName(profile.name);
      setUserEmail(profile.email);
      setProfileImage(profile.profileImage || "example.com");
    }
  }, [profile]);

  useEffect(() => {
    setData(orgProfile);
    setName(orgProfile.name);
    setEmail(orgProfile.email);
    setPhone(orgProfile.phone);
    setAbout(orgProfile.description);
    setShowImage(orgProfile.logo || "example.com");
    setAddress(
      orgProfile.address || {
        street: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
      },
    );
  }, [orgProfile]);

  const handleProfileImageUpload = async (event) => {
    let folderStructureImg = `organization/member/${profile?._id}`;
    const { resDataUrl, imageURL } = await uploadFile(
      event.target.files[0],
      folderStructureImg,
    );
    if (resDataUrl) {
      dispatch(updateMemberDetails(profile?._id, { profileImage: resDataUrl }));
      setShowImage(resDataUrl);
    }
  };

  const handleFileUpload = async (event) => {
    let folderStructureImg = `organization/${orgProfile.uniqueId}`;
    const { resDataUrl, imageURL } = await uploadFile(
      event.target.files[0],
      folderStructureImg,
    );
    if (resDataUrl) {
      dispatch(updateOrgDetails({ logo: resDataUrl }));
      setShowImage(resDataUrl);
    }
  };

  const handleEditProfile = () => {
    if (!userEmail || !userName) {
      let error = {};
      if (!userEmail) error.userEmail = "Email Is Required !";
      if (!userName) error.userName = "Name Is Required !";
      return setError({ ...error });
    } else {
      let profileData = {
        name: userName,
        email: userEmail,
      };
      dispatch(updateMemberDetails(profile?._id, profileData));
    }
  };

  const handleEditOrgDetails = () => {
    if (!name || !email) {
      let error = {};
      if (!name) error.name = "Name Is Required !";
      if (!email) error.email = "Email Is Required !";
      return setError({ ...error });
    }

    if (phone && phone.length < 10) {
      setError((prev) => ({
        ...prev,
        phone: "Phone Number Must be 10 digits",
      }));
      return;
    }

    let profileData = {
      name: name,
      email: email,
      phone: phone,
      description: about,
    };
    dispatch(updateOrgDetails(profileData));
  };

  const handlePassword = () => {
    if (!newPassword || !oldPassword || !confirmPassword) {
      let error = {};
      if (!newPassword) error.newPassword = "New Password Is Required !";
      if (!oldPassword) error.oldPassword = "Old Password Is Required !";
      if (!confirmPassword)
        error.confirmPassword = "Confirm Password Is Required !";
      return setError({ ...error });
    } else {
      if (newPassword !== confirmPassword) {
        setError({ confirmPassword: "Passwords do not match!" });
      }
      let payload = {
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmPassword: confirmPassword,
      };
      dispatch(resetPassword(payload));

      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }
  };

  const handleAddressChange = (target) => {
    const { name, value } = target;

    setAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitAddress = () => {
    dispatch(updateOrgDetails({ address }));
  };

  return (
    <PageContainer className="payment-setting">
      <div className="payment-setting-box p-3">
        <div className="row" style={{ padding: "15px" }}>
          <div className="col-lg-6 col-sm-12 ">
            <div className="mb-4 ">
              <div className="withdrawal-box profile-img d-flex flex-column align-items-center">
                <h6 className="text-start">Profile Image</h6>
                <div style={{ paddingTop: "14px" }}>
                  <label for="image" onChange={handleProfileImageUpload}>
                    <div className="avatar-img-icon">
                      <i className="fa-solid fa-camera d-flex justify-content-center rounded-circle  p-2 "></i>
                    </div>
                    <input
                      type="file"
                      name="image"
                      id="image"
                      accept="image/*"
                      style={{ display: "none" }}
                    />
                    {profileImage && (
                      <img
                        src={profileImage}
                        onError={(e) => {
                          e.target.src = UserImage;
                        }}
                      />
                    )}
                  </label>
                </div>
                <h5 className="fw-semibold boxCenter mt-2">{profile?.name}</h5>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-sm-12">
            <div className="mb-4">
              <div className="withdrawal-box payment-box">
                <h6 className="mb-0">Edit Profile</h6>
                <div className="row">
                  <form>
                    <div className="row">
                      <div className="col-12 withdrawal-input">
                        <Input
                          label={"Name"}
                          name={"username"}
                          type={"text"}
                          value={userName}
                          errorMessage={error.userName && error.userName}
                          placeholder={"Enter Detail...."}
                          onValueChange={(value) => {
                            setUserName(value);
                            if (!value) {
                              return setError({
                                ...error,
                                userName: `Name Is Required`,
                              });
                            } else {
                              return setError({
                                ...error,
                                userName: "",
                              });
                            }
                          }}
                        />
                      </div>
                      <div className="col-12 withdrawal-input border-0 mt-2">
                        <Input
                          label={"Email"}
                          name={"useremail"}
                          value={userEmail}
                          type={"text"}
                          disabled
                          errorMessage={error.userEmail && error.userEmail}
                          placeholder={"Enter Detail...."}
                          onValueChange={(value) => {
                            setUserEmail(value);
                            if (!value) {
                              return setError({
                                ...error,
                                userEmail: `Email Is Required`,
                              });
                            } else {
                              return setError({
                                ...error,
                                userEmail: "",
                              });
                            }
                          }}
                        />
                      </div>
                      <div className="col-12 d-flex mt-3 justify-content-end">
                        <Button
                          type={"button"}
                          onClick={handleEditProfile}
                          className={"submit"}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-sm-12">
            <div className="mb-4">
              <div className="withdrawal-box payment-box">
                <h6 className="mb-0">Change Password</h6>
                <div className="row">
                  <form>
                    <div className="row">
                      <div className="col-12 withdrawal-input">
                        <Input
                          label={"Old Password"}
                          name={"oldPassword"}
                          value={oldPassword}
                          type={"password"}
                          errorMessage={error.oldPassword && error.oldPassword}
                          placeholder={"Enter Old Password"}
                          onValueChange={(value) => {
                            setOldPassword(value);
                            if (!value) {
                              return setError({
                                ...error,
                                oldPassword: `OldPassword Is Required`,
                              });
                            } else {
                              return setError({
                                ...error,
                                oldPassword: "",
                              });
                            }
                          }}
                        />
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 withdrawal-input border-0 mt-2">
                        <Input
                          label={"New Password"}
                          name={"newPassword"}
                          value={newPassword}
                          errorMessage={error.newPassword && error.newPassword}
                          type={"password"}
                          placeholder={"Enter New Password"}
                          onValueChange={(value) => {
                            setNewPassword(value);
                            if (!value) {
                              return setError({
                                ...error,
                                newPassword: `New Password Is Required`,
                              });
                            } else {
                              return setError({
                                ...error,
                                newPassword: "",
                              });
                            }
                          }}
                        />
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 withdrawal-input border-0 mt-2">
                        <Input
                          label={"Confirm Password"}
                          name={"confirmPassword"}
                          value={confirmPassword}
                          type={"password"}
                          errorMessage={
                            error.confirmPassword && error.confirmPassword
                          }
                          placeholder={"Enter Confirm Password"}
                          onValueChange={(value) => {
                            setConfirmPassword(value);
                            if (!value) {
                              return setError({
                                ...error,
                                confirmPassword: `Confirm Password Is Required`,
                              });
                            } else {
                              return setError({
                                ...error,
                                confirmPassword: "",
                              });
                            }
                          }}
                        />
                      </div>
                      <div className="col-12 d-flex mt-3 justify-content-end">
                        <Button
                          type={"button"}
                          onClick={handlePassword}
                          className={"submit"}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 "></div>

          <div className="col-12">
            <br />
            <br />
          </div>

          <h5 className="mb-3">Organization</h5>

          {profile?.role === "org_owner" ? (
            <>
              <div className="col-lg-6 col-sm-12 ">
                <div className="mb-4 ">
                  <div className="withdrawal-box profile-img d-flex flex-column align-items-center">
                    <h6 className="text-start">Organization Logo</h6>
                    <div style={{ paddingTop: "14px" }}>
                      <label for="image" onChange={handleFileUpload}>
                        <div className="avatar-img-icon">
                          <i className="fa-solid fa-camera d-flex justify-content-center rounded-circle  p-2 "></i>
                        </div>
                        <input
                          type="file"
                          name="image"
                          id="image"
                          accept="image/*"
                          style={{ display: "none" }}
                        />
                        {showImage && (
                          <img
                            src={showImage}
                            onError={(e) => {
                              e.target.src = UserImage;
                            }}
                          />
                        )}
                      </label>
                    </div>
                    <h5 className="fw-semibold boxCenter mt-2">{data?.name}</h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-sm-12">
                <div className="mb-4">
                  <div className="withdrawal-box payment-box">
                    <h6 className="mb-0">Edit Organization Details</h6>
                    <div className="row">
                      <form>
                        <div className="row">
                          <div className="col-12 withdrawal-input">
                            <Input
                              label={"Name"}
                              name={"name"}
                              type={"text"}
                              value={name}
                              errorMessage={error.name && error.name}
                              placeholder={"Enter Detail...."}
                              onValueChange={(value) => {
                                setName(value);
                                if (!value) {
                                  return setError({
                                    ...error,
                                    name: `Name Is Required`,
                                  });
                                } else {
                                  return setError({
                                    ...error,
                                    name: "",
                                  });
                                }
                              }}
                            />
                          </div>
                          <div className="col-12 withdrawal-input border-0 mt-2">
                            <Input
                              label={"Email"}
                              name={"email"}
                              value={email}
                              type={"text"}
                              errorMessage={error.email && error.email}
                              placeholder={"Enter Detail...."}
                              onValueChange={(value) => {
                                setEmail(value);
                                if (!value) {
                                  return setError({
                                    ...error,
                                    email: `Email Is Required`,
                                  });
                                } else {
                                  return setError({
                                    ...error,
                                    email: "",
                                  });
                                }
                              }}
                            />
                          </div>
                          <div className="col-12 withdrawal-input border-0 mt-2">
                            <Input
                              label="Phone"
                              type="number"
                              placeholder="Enter Phone"
                              value={phone}
                              onChange={(e) => {
                                e.target.value.length == 10
                                  ? setError((prev) => ({
                                      ...prev,
                                      phone: "",
                                    }))
                                  : null;
                                e.target.value.length <= 10
                                  ? setPhone(e.target.value)
                                  : e.preventDefault();
                              }}
                              errorMessage={error.phone && error.phone}
                            />
                          </div>
                          <div className="col-12 withdrawal-input border-0 mt-2">
                            <Textarea
                              label={"About"}
                              placeholder={"About"}
                              rows={4}
                              value={about}
                              onValueChange={(value) => {
                                setAbout(value);
                              }}
                            />
                          </div>
                          <div className="col-12 d-flex mt-3 justify-content-end">
                            <Button
                              type={"button"}
                              onClick={handleEditOrgDetails}
                              className={"submit"}
                            >
                              Submit
                            </Button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-sm-12">
                <div className="mb-4">
                  <div className="withdrawal-box payment-box">
                    <h6 className="mb-0">Address</h6>
                    <div className="row">
                      <form>
                        <div className="row">
                          <div className="col-12 withdrawal-input">
                            <Input
                              label={"Street"}
                              name={"street"}
                              value={address.street}
                              placeholder="Street"
                              onChange={(event) =>
                                handleAddressChange(event.target)
                              }
                            />
                          </div>
                          <div className="col-6 withdrawal-input border-0 mt-2">
                            <Input
                              label={"City"}
                              name={"city"}
                              value={address.city}
                              placeholder="City"
                              onChange={(event) =>
                                handleAddressChange(event.target)
                              }
                            />
                          </div>
                          <div className="col-6 withdrawal-input border-0 mt-2">
                            <Input
                              label={"State"}
                              name={"state"}
                              value={address.state}
                              placeholder="State"
                              onChange={(event) =>
                                handleAddressChange(event.target)
                              }
                            />
                          </div>
                          <div className="col-6 withdrawal-input border-0 mt-2">
                            <Input
                              label={"Country"}
                              name={"country"}
                              value={address.country}
                              placeholder="Country"
                              onChange={(event) =>
                                handleAddressChange(event.target)
                              }
                            />
                          </div>
                          <div className="col-6 withdrawal-input border-0 mt-2">
                            <Input
                              label={"Postal Code"}
                              name={"postalCode"}
                              value={address.postalCode}
                              placeholder="Postal Code"
                              onChange={(event) =>
                                handleAddressChange(event.target)
                              }
                            />
                          </div>
                          <div className="col-12 d-flex mt-3 justify-content-end">
                            <Button
                              type={"button"}
                              onClick={submitAddress}
                              className={"submit"}
                            >
                              Submit
                            </Button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="col-lg-6 col-12 d-flex flex-column flex-md-row flex-wrap gap-4">
              <div className="">
                <img
                  className="object-fit-contain h-auto"
                  src={showImage}
                  width={150}
                  onError={(e) => {
                    e.target.src = UserImage;
                  }}
                />
              </div>
              <div className="flex-grow-1">
                <p className="fs-4 mb-1">{name}</p>
                <div className="">
                  <p className="mb-1">
                    <span>Email : </span> {email}
                  </p>
                  <p className="mb-1">
                    <span>Phone : </span> {phone}
                  </p>
                </div>
              </div>
              {about && (
                <div className="col-12">
                  <p className="fw-semibold mb-1">About</p>
                  {about}
                </div>
              )}
            </div>
          )}

          {profile?.role === "org_owner" && <OwnershipSection />}
        </div>
      </div>
    </PageContainer>
  );
}
export default connect(null, {})(OrgProfile);

const OwnershipSection = () => {
  const dispatch = useDispatch();

  const [members, setMembers] = useState([]);
  const [selected, setSelected] = useState("");

  const handleTransferOwnership = () => {
    apiInstance
      .put(`organization/transfer-ownership`, {
        newOwnerId: selected,
      })
      .then((res) => {
        if (res.status) {
          setToast("success", "Ownership transferred successfully");
          dispatch(getOrgProfile());
          dispatch(getOrgMemberProfile());
        }
      });
  };

  useEffect(() => {
    apiInstance
      .get(
        `organization/members?limit=100&role=org_admin&invitationStatus=joined`,
      )
      .then((res) => {
        setMembers(res.data.members);
      });
  }, [dispatch]);

  return (
    <div className="mt-4 ">
      <h5 className="mb-3">Ownership</h5>
      <p className="text-secondary">
        <i>Only one owner allowed in an organization.</i> <br />
        <i>Transferring ownership will demote you to Admin role.</i>
      </p>
      <div className="d-flex align-items-center gap-2">
        <div className="col-sm-4">
          <Select
            options={members.map((member) => ({
              value: member._id,
              label: `${member.name} (${member.email})`,
            }))}
            value={selected}
            onValueChange={(value) => setSelected(value)}
          />
        </div>
        <Button
          className="outlined flex-grow-1"
          style={{ maxWidth: "max-content" }}
          disabled={!selected}
          onClick={handleTransferOwnership}
        >
          Transfer
        </Button>
      </div>
    </div>
  );
};
